'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('filingDetailController', function (docketService, orderService, jobService, resourceService, userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $q, $timeout, scroll, geolocation) {
    // Main Variables For Doing Stuff
    $scope.moment = moment;
    $scope.docketsFiling = null;
    $scope.filingMode = null;

    // Base Access Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentTab = "General";
    $scope.docketLoadingError = null;
    $scope.singleUom = false;
    $scope.singleUomAbbreviation = ''
    $scope.totalAmount = 0;

    $scope.userCanDoAction = userService.userCanDoAction;

    // Include responsive utilities and UI Functionality
    $scope.splitListFunc = new splitListInterface($scope, $stateParams);

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.currentActiveTab = function () {
      return $scope.currentTab;
    }

    $scope.$parent.prepareForFilingFromParent = function () {
      $scope.docketFiling = {};
      $scope.docketFiling.loading = true;
      $scope.docketFiling.loadingType = 'getting';
      $scope.docketLoadingError = null;
    }

    $scope.$parent.loadingErrorFromParent = function (err) {
      $scope.docketLoadingError = err;
      $scope.docketFiling.loading = false;
    }

    $scope.splitQuantityUpdated = function (activity) {
      activity.splitPercentage = parseFloat((activity.splitQuantity / $scope.totalAmount * 100).toFixed(4))
      activity.splitPercentage_display = parseFloat(activity.splitPercentage.toFixed(2))
    }

    $scope.splitPercentageUpdated = function (activity) {

      if (activity.splitPercentage.toFixed(2) == activity.splitPercentage_display.toFixed(2)) {
        return
      }

      activity.splitPercentage = activity.splitPercentage_display
      activity.splitQuantity = parseFloat(($scope.totalAmount * activity.splitPercentage / 100).toFixed(2))
    }

    $scope.splitQuantityBlur = function (activity) {
      activity.splitQuantity = parseFloat(parseFloat(activity.splitQuantity).toFixed(2))
      $scope.splitQuantityUpdated(activity)
    }

    $scope.totalPercentage = function () {
      if ($scope.docketFiling == null || $scope.docketFiling.activityCodes == null) {
        return 0;
      }

      return $scope.docketFiling.activityCodes.map(x => Number.parseFloat(x.splitPercentage)).reduce(function (a, b) { return a + b }, 0).toFixed(2)
    }

    $scope.totalQuantity = function () {
      if ($scope.docketFiling == null || $scope.docketFiling.activityCodes == null) {
        return 0;
      }

      return $scope.docketFiling.activityCodes.map(x => Number.parseFloat(x.splitQuantity)).reduce(function (a, b) { return a + b }, 0).toFixed(2)
    }

    $scope.$parent.loadBulkDocketsFromParent = function (dockets) {
      $scope.docketFiling.dockets = dockets;
      $scope.docketLoadingError = null;

      var uomTypes = _.flatten(dockets.map(docket => docket.resources)).map(resource => resource.resource.uom);
      $scope.singleUom = _.uniq(uomTypes.map(uom => uom.id)).length == 1;
      if ($scope.singleUom) {
        $scope.singleUomAbbreviation = uomTypes[0].abbreviation
      }

      var fullResourcesSummary = {};
      // generate resource and line summary
      for (var i = 0; i < dockets.length; i++) {
        var linesSummary = [];
        for (var j = 0; j < dockets[i].resources.length; j++) {
          var resourceId = dockets[i].resources[j].resource.id;
          if (fullResourcesSummary[resourceId] == null) {
            var resourceSummary = {};
            resourceSummary.interactions = {};
            resourceSummary.resource = dockets[i].resources[j].resource;
            fullResourcesSummary[resourceId] = resourceSummary;
          }
          for (var k = 0; k < dockets[i].resources[j].interactions.length; k++) {
            var childResource = dockets[i].resources[j].interactions[k].resource;
            var quantity = dockets[i].resources[j].interactions[k].quantity;
            var interaction = dockets[i].resources[j].interactions[k];
            var lineSummary = {};
            lineSummary.resource = childResource;
            lineSummary.quantity = quantity;
            lineSummary.interaction = interaction;
            lineSummary.activityCodes = [];
            // get activityCode for line
            if (dockets[i].existingDocketFile && dockets[i].existingDocketFile.fileMethod == 'lines' && dockets[i].existingDocketFile.lineCodes) {
              var lineCodes = dockets[i].existingDocketFile.lineCodes;
              for (var l = 0; l < lineCodes.length; l++) {
                if (lineCodes[k].interaction.id == lineSummary.interaction.id) {
                  // got the right line code = now get the populated file code
                  if (lineCodes[k].populatedFileCodes) {
                    for (var fc = 0; fc < lineCodes[k].populatedFileCodes.length; fc++) {
                      var newActivityCode = lineCodes[k].populatedFileCodes[fc]
                      newActivityCode.percentage_display = parseFloat(newActivityCode.percentage.toFixed(2))
                      newActivityCode.quantity = parseFloat((lineSummary.interaction.quantity * newActivityCode.percentage / 100).toFixed(2))

                      lineSummary.activityCodes.push(newActivityCode);
                    }
                  }
                  break;
                }
              }
            }

            if (lineSummary.activityCodes == null || lineSummary.activityCodes.length == 0) {
              lineSummary.activityCodes = [{
                  percentage: 100,
                  percentage_display: 100,
                  quantity: quantity
              }]
            }

            linesSummary.push(lineSummary);
            if (fullResourcesSummary[resourceId].interactions[interaction.interactionTemplate.id] == null) {
              var interactionSummary = {};
              interactionSummary.interaction = interaction;
              interactionSummary.quantity = quantity;
              fullResourcesSummary[resourceId].interactions[interaction.interactionTemplate.id] = interactionSummary;
            } else {
              fullResourcesSummary[resourceId].interactions[interaction.interactionTemplate.id].quantity += quantity;
            }
          }
        }
        if (dockets[i].existingDocketFile && dockets[i].existingDocketFile.fileMethod == 'split') {
          if (dockets[i].existingDocketFile.lineCodes && dockets[i].existingDocketFile.lineCodes[0] && dockets[i].existingDocketFile.lineCodes[0].populatedFileCodes) {
            var fileCodes = [];
            for (var j = 0; j < dockets[i].existingDocketFile.lineCodes[0].populatedFileCodes.length; j++) {
              var thisCode = dockets[i].existingDocketFile.lineCodes[0].populatedFileCodes[j].fileCode;
              thisCode.splitPercentage = dockets[i].existingDocketFile.lineCodes[0].populatedFileCodes[j].percentage;
              thisCode.splitPercentage_display = parseFloat(thisCode.splitPercentage.toFixed(2))
              fileCodes.push(thisCode);
            }
            dockets[i].fileCodes = fileCodes;
          }
        }
        dockets[i].linesSummary = linesSummary;
        // TODO: generate resource summary for docket
      }

      // convert resources summary to array
      var fullLinesSummary = [];
      var keys = Object.keys(fullResourcesSummary);
      for (var i = 0; i < keys.length; i++) {
        var interactionKeys = Object.keys(fullResourcesSummary[keys[i]].interactions);
        for (var j = 0; j < interactionKeys.length; j++) {
          var lineSummary = {};
          lineSummary.resource = fullResourcesSummary[keys[i]].resource;
          lineSummary.interaction = fullResourcesSummary[keys[i]].interactions[interactionKeys[j]].interaction;
          lineSummary.quantity = fullResourcesSummary[keys[i]].interactions[interactionKeys[j]].quantity;
          lineSummary.activityCodes = [{
            percentage: 100,
            percentage_display: 100,
            quantity: lineSummary.quantity
          }]
          fullLinesSummary.push(lineSummary);
        }
      }
      $scope.docketFiling.linesSummary = fullLinesSummary;

      if (dockets.length == 1) {
        // No existing file code for the selected docket - prefill lines summary
        var linesSummary = [];
        for (var i = 0; i < dockets[0].resources.length; i++) {
          for (var j = 0; j < dockets[0].resources[i].interactions.length; j++) {
            var childResource = dockets[0].resources[i].interactions[j].resource;
            var quantity = dockets[0].resources[i].interactions[j].quantity;
            var interaction = dockets[0].resources[i].interactions[j];
            var lineSummary = {};
            lineSummary.resource = childResource;
            lineSummary.quantity = quantity;
            lineSummary.interaction = interaction;
            //lineSummary.activityCode = null;
            linesSummary.push(lineSummary);
          }
        }
        $scope.docketFiling.linesSummary = linesSummary;

        // generate resource summary for docket
        var resourceSummary = {};
        for (var i = 0; i < dockets[0].resources.length; i++) {
          for (var j = 0; j < dockets[0].resources[i].interactions.length; j++) {
            var thisInteraction = dockets[0].resources[i].interactions[j];
            var thisResource = dockets[0].resources[i].interactions[j].resource;
            if (resourceSummary[thisResource.id]) {
              resourceSummary[thisResource.id].totalQuantity += thisInteraction.quantity;
            } else {
              resourceSummary[thisResource.id] = { resource: thisResource, totalQuantity: thisInteraction.quantity };
            }
          }
        }
        // convert to array
        var resourceSummaryList = [];
        var keys = Object.keys(resourceSummary);
        for (var i = 0; i < keys.length; i++) {
          resourceSummaryList.push(resourceSummary[keys[i]]);
        }
        $scope.docketFiling.resourceSummary = resourceSummaryList;
        $scope.docketFiling.dockets[0].detailOpen = true;
      }

      if (dockets.length == 1 && dockets[0].existingDocketFile) {
        $scope.docketFiling.filed = true;
        $scope.docketFiling.method = dockets[0].existingDocketFile.fileMethod;

        if ($scope.docketFiling.method == 'split') {
          if (dockets[0].existingDocketFile.lineCodes && dockets[0].existingDocketFile.lineCodes.length > 0) {
            var activityCodes = [];
            if (dockets[0].existingDocketFile.lineCodes[0].populatedFileCodes) {
              var fileCodesList = dockets[0].existingDocketFile.lineCodes[0].populatedFileCodes;
              for (var i = 0; i < fileCodesList.length; i++) {
                var code = fileCodesList[i].fileCode;
                var splitPercentage = fileCodesList[i].percentage;
                var newActivity = { fileCode: code, splitPercentage, splitPercentage_display: parseFloat(splitPercentage.toFixed(2)) };
                activityCodes.push(newActivity);
              }
            }
            $scope.docketFiling.activityCodes = activityCodes;
          }
        } else if ($scope.docketFiling.method == 'lines') {
          if (dockets[0].existingDocketFile.lineCodes && dockets[0].existingDocketFile.lineCodes.length > 0) {
            var linesSummary = [];
            for (var i = 0; i < dockets[0].resources.length; i++) {
              for (var j = 0; j < dockets[0].resources[i].interactions.length; j++) {
                var childResource = dockets[0].resources[i].interactions[j].resource;
                var quantity = dockets[0].resources[i].interactions[j].quantity;
                var interaction = dockets[0].resources[i].interactions[j];
                var lineSummary = {};
                lineSummary.resource = childResource;
                lineSummary.quantity = quantity;
                lineSummary.interaction = interaction;
                lineSummary.activityCodes = [];
                // find existing activity code
                for (var k = 0; k < dockets[0].existingDocketFile.lineCodes.length; k++) {
                  if (dockets[0].existingDocketFile.lineCodes[k].interaction.id == lineSummary.interaction.id) {

                    if (lineCodes[k].populatedFileCodes) {
                      for (var fc = 0; fc < lineCodes[k].populatedFileCodes.length; fc++) {
                        var newActivityCode = lineCodes[k].populatedFileCodes[fc]
                        newActivityCode.percentage_display = parseFloat(newActivityCode.percentage.toFixed(2))
                        newActivityCode.quantity = parseFloat((lineSummary.interaction.quantity * newActivityCode.percentage / 100).toFixed(2))

                        lineSummary.activityCodes.push(newActivityCode);
                      }
                    }
                    break;
                  }
                }

                if (lineSummary.activityCodes == null || lineSummary.activityCodes.length == 0) {
                  lineSummary.activityCodes = [{
                      percentage: 100,
                      percentage_display: 100,
                      quantity: quantity
                  }]
                }

                linesSummary.push(lineSummary);
              }
            }
            $scope.docketFiling.linesSummary = linesSummary;
          }
        }
      } else {
        $scope.docketFiling.filed = false;
        $scope.docketFiling.method = null;
      }

      $scope.totalAmount = $scope.docketFiling.linesSummary.map(line => line.quantity).reduce((a, b) => a + b, 0)

      $scope.docketFiling.method = 'split'
      $scope.addSplitFileCodeDesktop()

      $scope.docketFiling.activityCodes.forEach($scope.splitPercentageUpdated)

      $scope.docketFiling.loading = false;
    }

    $scope.$parent.clearDocketFilingFromParent = function () {
      $scope.docketFiling = null;
    }

    /*****************************/
    /***** Main UI Functions *****/
    /*****************************/

    $scope.changeFileMethod = function (method, docketFiling) {
      if (method == 'split') {
        docketFiling.method = 'split';
        if (docketFiling.activityCodes == null || docketFiling.activityCodes.length <= 0) {
          $scope.addSplitFileCode();
        }
      } else {
        docketFiling.method = method;
      }
    }

    $scope.changeFileMethodDesktop = function (method, docketFiling) {
      if (method == 'split') {
        $scope.addSplitFileCodeDesktop();
      }
      docketFiling.method = method;
    }

    $scope.addSplitFileCode = function () {
      if ($scope.docketFiling.activityCodes == null) {
        $scope.docketFiling.activityCodes = [];
      }

      $scope.$parent.selectActivityForDocketFile(null, function (activity) {
        if (activity != null) {
          var totalPercentage = 0;
          for (var i = 0; i < $scope.docketFiling.activityCodes.length; i++) {
            if ($scope.docketFiling.activityCodes[i].splitPercentage) {
              totalPercentage += $scope.docketFiling.activityCodes[i].splitPercentage;
            }
          }

          var remainingPercentage = 0;
          if (totalPercentage < 100) {
            remainingPercentage = parseFloat(100 - totalPercentage);
          }

          const splitQuantity = parseFloat($scope.totalAmount * remainingPercentage / 100)
          $scope.docketFiling.activityCodes.push({ splitPercentage: remainingPercentage, splitPercentage_display: parseFloat(remainingPercentage.toFixed(2)), fileCode: activity, splitQuantity });
        }
      });
    }

    $scope.addSplitFileCodeDesktop = function () {
      if ($scope.docketFiling.activityCodes == null) {
        $scope.docketFiling.activityCodes = [];
      }

      var totalPercentage = 0;
      for (var i = 0; i < $scope.docketFiling.activityCodes.length; i++) {
        if ($scope.docketFiling.activityCodes[i].splitPercentage) {
          totalPercentage += Number.parseFloat($scope.docketFiling.activityCodes[i].splitPercentage);
        }
      }

      var remainingPercentage = 0;
      if (totalPercentage < 100) {
        remainingPercentage = parseFloat((100 - totalPercentage).toFixed(2));
      }

      const splitQuantity = parseFloat(($scope.totalAmount * remainingPercentage / 100).toFixed(2))
      $scope.docketFiling.activityCodes.push({ splitPercentage: remainingPercentage, splitPercentage_display: parseFloat(remainingPercentage.toFixed(2)), fileCode: null, splitQuantity });
    }

    $scope.removeSplitFileCode = function (activityCode) {
      var index = $scope.docketFiling.activityCodes.indexOf(activityCode);
      if (index != -1) {
        $scope.docketFiling.activityCodes.splice(index, 1);
      }
    }

    $scope.selectActivityForLine = function (docketFiling, line) {
      var existing = [];
      if (line.activityCode != null) {
        existing.push(line.activityCode);
      }
      $scope.$parent.selectActivityForDocketFile(existing, function (activity) {
        if (activity != null) {
          line.activityCode = activity;
        }
      });
    }

    $scope.selectActivityForSplit = function (docketFiling, activityCode) {
      // get list of used file codes
      var existing = [];
      if (docketFiling.activityCodes != null) {
        for (var i = 0; i < docketFiling.activityCodes.length; i++) {
          if (docketFiling.activityCodes[i].fileCode != null) {
            existing.push(docketFiling.activityCodes[i].fileCode);
          }
        }
      }
      $scope.$parent.selectActivityForDocketFile(existing, function (activity) {
        if (activity != null) {
          activityCode.fileCode = activity;
        }
      });
    }

    $scope.searchFileCodes = function (searchText) {
      return $q(function (resolve, reject) {
        var params = {};
        if (searchText != null) {
          if (searchText != "") {
            params.search = searchText;
          } else {
            resolve([]);
            return;
          }
        }
        docketService.getFileCodes(params, function (fileCodes) {
          resolve(fileCodes);
        }, function (err) {
          reject("err");
        });
      });
    }

    /****************************/
    /***** UI Functionality *****/
    /****************************/

    /* F/E Permission Checking */
    $scope.userHasPermission = function (permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    /***********************************/
    /***** Alert Parent Controller *****/
    /***********************************/

    $scope.$parent.filingDetailControllerReady();




    $scope.activityCodePercentageUpdated = function(line, activityCode, index) {
      activityCode.percentage = activityCode.percentage_display
      activityCode.quantity = parseFloat((line.quantity * activityCode.percentage / 100).toFixed(2))

      if (line.activityCodes.length == 2) {
        const otherActivityCode = line.activityCodes[index == 0 ? 1 : 0]
        otherActivityCode.percentage = 100 - activityCode.percentage
        otherActivityCode.percentage_display = parseFloat(otherActivityCode.percentage.toFixed(2))
        otherActivityCode.quantity = parseFloat((line.quantity * otherActivityCode.percentage / 100).toFixed(2))
      }
    }

    $scope.activityCodeQuantityUpdated = function(line, activityCode, index) {
      activityCode.percentage = parseFloat((activityCode.quantity / line.quantity * 100).toFixed(4))
      activityCode.percentage_display = parseFloat(activityCode.percentage.toFixed(2))

      if (line.activityCodes.length == 2) {
        const otherActivityCode = line.activityCodes[index == 0 ? 1 : 0]
        otherActivityCode.percentage = 100 - activityCode.percentage
        otherActivityCode.percentage_display = parseFloat(otherActivityCode.percentage.toFixed(2))
        otherActivityCode.quantity = parseFloat((line.quantity * otherActivityCode.percentage / 100).toFixed(2))
      }
    }

    $scope.getLineTotalPercent = function(line) {
      return line.activityCodes
        .map(activityCode => activityCode.percentage)
        .reduce((a, b) => a + b, 0)
    }

    $scope.splitLineFiling = function (line) {
      const remainingPercent = 100 - $scope.getLineTotalPercent(line)

      line.activityCodes.push({
          percentage: remainingPercent,
          percentage_display: parseFloat(remainingPercent.toFixed(2)),
          quantity: parseFloat((line.quantity * remainingPercent / 100).toFixed(2))
      })
    }

    $scope.removeSplitLineFiling = function(line, index) {
      line.activityCodes.splice(index, 1);
      if (line.activityCodes.length == 1) {
        line.activityCodes[0].percentage = 100;
      }
    }


  });




// WEBPACK FOOTER //
// ./src/controllers/filing/detailController.js